import axios from "axios";
import moment from "moment";
//state
export var trustpilotState = {
  business_units: [],
  insights_tp: [],
  starRating_tp: [],
  topics_tp: [],
  category_topic_tp: [],
  commentcount_tp: [],
  analyzeinsightfirst_tp: [],
  analyzeinsightthird_tp: [],
  analyzeinsightfourth_tp: [],
  analyzeinsightfifth_tp: [],
  reviews_tp: [],

  avg_rating: [],
  avg_rating_prevweek: [],
  avg_comment: 0,
  avg_comment_prevweek: 0,
  month_avg_rating: 0,
  month_avg_rating_prev: 0,
  reviewsandcommentdata: [],
  starratingpiechartdata: [],
  commenttabledata: [],
  reviewsvscommentovertimedata: [],
  avgstarratingpermonth: [],
  avgstarratingperday: [],

  avg_rating_location: [],
  avg_comment_location: 0,
  month_avg_rating_location: 0,
  reviewsandcommentdata_location: [],
  starratingpiechartdata_location: [],
  commenttabledata_location: [],
  reviewsvscommentovertimedata_location: [],
  avgstarratingpermonth_location: [],
  avgstarratingperday_location: [],

  scoretagcommentCount: [],
  sentimentanalysisCount: [],
  starRatingandCommentData: [],
  scoretagratingovertime: [],
  categoryratingovertime: [],
  topicstarratingCount: [],
  topicavgstarrating: [],
  formdataCount: [],

  status_trustpilot: "",
  status_dashboard: "",

  frescura_reviews: [],
  frescura_comments: [],
};
var user_context = JSON.parse(localStorage.getItem("user_context"));
var uid = localStorage.getItem("uid");
var pass = localStorage.getItem("pass");

//getters
export var trustpilotGetters = {
  //funciones para optener informacion del state
  getBusinessUnits: (state) => state.business_units,

  getdatastudioSentimentTP: (state) => state.insights_tp,
  getdatastudioSentimentStarRatingTP: (state) => state.starRating_tp,
  getdatastudioTopicsTP: (state) => state.topics_tp,
  getCategoryNameTopicsTP: (state) => state.category_topic_tp,
  getcommentCountTP: (state) => state.commentcount_tp,
  getanalyzeInsightFirstTP: (state) => state.analyzeinsightfirst_tp,
  getanalyzeInsightThirdTP: (state) => state.analyzeinsightthird_tp,
  getanalyzeInsightFourthTP: (state) => state.analyzeinsightfourth_tp,
  getanalyzeInsightFifthTP: (state) => state.analyzeinsightfifth_tp,
  getanalyzeInsightFifthTP: (state) => state.analyzeinsightfifth_tp,

  getGbaReviewsTP: (state) => state.reviews_tp,

  get7daysavgRating: (state) => state.avg_rating,
  getPrevWeek7daysavgRating: (state) => state.avg_rating_prevweek,
  get7monthsavgRating: (state) => state.month_avg_rating,
  getPrev7monthsavgRating: (state) => state.month_avg_rating_prev,
  get7dayscomments: (state) => state.avg_comment,
  get7daysPrevWeekcomments: (state) => state.avg_comment_prevweek,
  getreviewsandcommentgraphdata: (state) => state.reviewsandcommentdata,
  getstarratingpiechartdata: (state) => state.starratingpiechartdata,
  getcommenttabledata: (state) => state.commenttabledata,
  getreviewsvscommentovertime: (state) => state.reviewsvscommentovertimedata,
  getavgstarratingpermonth: (state) => state.avgstarratingpermonth,
  getavgstarratingperday: (state) => state.avgstarratingperday,

  get7daysavgRatingbyLocation: (state) => state.avg_rating_location,
  get7monthsavgRatingbyLocation: (state) => state.month_avg_rating_location,
  get7dayscommentsbyLocation: (state) => state.avg_comment_location,
  getreviewsandcommentgraphdatabyLocation: (state) =>
    state.reviewsandcommentdata_location,
  getstarratingpiechartdatabyLocation: (state) =>
    state.starratingpiechartdata_location,
  getcommenttabledatabyLocation: (state) => state.commenttabledata_location,
  getreviewsvscommentovertimebyLocation: (state) =>
    state.reviewsvscommentovertimedata_location,
  getavgstarratingpermonthbyLocation: (state) =>
    state.avgstarratingpermonth_location,
  getavgstarratingperdaybyLocation: (state) =>
    state.avgstarratingperday_location,

  getscoreTagCommentCount: (state) => state.scoretagcommentCount,
  getsentimentanalysisCount: (state) => state.sentimentanalysisCount,
  getstarRatingandCommentData: (state) => state.starRatingandCommentData,
  getscoretagratingovertime: (state) => state.scoretagratingovertime,
  getcategoryratingovertime: (state) => state.categoryratingovertime,
  gettopicstarratingCount: (state) => state.topicstarratingCount,
  gettopicavgstarratingCount: (state) => state.topicavgstarrating,
  getformdataCount: (state) => state.formdataCount,

  getfrescuraReviews: (state) => state.frescura_reviews,
  getfrescuraComments: (state) => state.frescura_comments,
};

//actions
export var trustpilotActions = {
  async getavgstarratingperdaybyLocation({ commit }, payload) {
    commit("trustpilot_request");
    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      if (create_date.length > 0) {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
          ["create_date", ">=", `${create_date[0]}`],
          ["create_date", "<", `${create_date[1]}`],
        ];
      } else {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
        ];
      }
    } else if (starRatings.length === 0 && create_date.length > 0) {
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">=", `${create_date[0]}`],
        ["create_date", "<", `${create_date[1]}`],
      ];
    } else {
      domain = [["location_id", "in", location_ids]];
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context, //{"uid":8,"lang":"es_ES"},
          domain: domain,
          //[["location_id.partner_id","in",location_ids]], //(For partner)
          // "domain": [["location_id","in",[x,x,x,x]]], (For locations)
          fields: ["starRating_avg", "create_date"],
          groupby: ["create_date:day", "starRating_avg"],
          lazy: false,
          orderby: "",
        },
        method: "read_group",
        model: "brand_whisper.review",
        args: [],
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/read_group", req_data)
      .then((res) => {
        var avgstarratingperday_location = res.data.result;
        //console.log.log("avgstarratingperday_location 222:::: ", res.data.result);
        commit(
          "avgstarratingperday_location_success",
          avgstarratingperday_location
        );
        return res;
      })
      .catch((err) => {
        commit("dashboard_error111", err);
        return err;
      });
  },

  async getavgstarratingpermonthbyLocation({ commit }, payload) {
    commit("trustpilot_request");
    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      if (create_date.length > 0) {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
          ["create_date", ">=", `${create_date[0]}`],
          ["create_date", "<", `${create_date[1]}`],
        ];
      } else {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
        ];
      }
    } else if (starRatings.length === 0 && create_date.length > 0) {
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">=", `${create_date[0]}`],
        ["create_date", "<", `${create_date[1]}`],
      ];
    } else {
      domain = [["location_id", "in", location_ids]];
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context, //{"uid":8,"lang":"es_ES"},,
          domain: [["location_id", "in", location_ids]], //(For partner)
          // "domain": [["location_id","in",[x,x,x,x]]], (For locations)
          fields: ["starRating_avg", "create_date"],
          groupby: ["create_date:month", "starRating_avg"],
          lazy: false,
          orderby: "",
        },
        method: "read_group",
        model: "brand_whisper.review",
        args: [],
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/read_group", req_data)
      .then((res) => {
        var avgstarratingpermonth_location = res.data.result;
        //console.log.log("getavgstarratingpermonth_location 222:::: ", res.data.result);
        commit(
          "avgstarratingpermonth_location_success",
          avgstarratingpermonth_location
        );
        return res;
      })
      .catch((err) => {
        commit("dashboard_error111", err);
        return err;
      });
  },

  async getreviewsvscommentovertimebyLocation({ commit }, payload) {
    commit("trustpilot_request");
    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      if (create_date.length > 0) {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
          ["create_date", ">=", `${create_date[0]}`],
          ["create_date", "<", `${create_date[1]}`],
        ];
      } else {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
        ];
      }
    } else if (starRatings.length === 0 && create_date.length > 0) {
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">=", `${create_date[0]}`],
        ["create_date", "<", `${create_date[1]}`],
      ];
    } else {
      domain = [["location_id", "in", location_ids]];
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context, //{"uid":8,"lang":"es_ES"},
          domain: domain,
          //[["location_id","in",location_ids]],// (For partner)
          // "domain": [["location_id","in",[x,x,x,x]]], (For locations)
          fields: ["has_comment", "create_date"],
          groupby: ["create_date:month", "has_comment"],
          lazy: false,
          orderby: "",
        },
        method: "read_group",
        model: "brand_whisper.review",
        args: [],
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/read_group", req_data)
      .then((res) => {
        var reviewsvscommentovertimedata_location = res.data.result;
        //console.log.log("reviewsvscommentovertimedata_location 222:::: ", res.data.result);
        commit(
          "reviewdataovertime_location_success",
          reviewsvscommentovertimedata_location
        );
        return res;
      })
      .catch((err) => {
        commit("dashboard_error111", err);
        return err;
      });
  },

  async getcommenttabledatabyLocation({ commit }, payload) {
    commit("trustpilot_request");
    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      if (create_date.length > 0) {
        domain = [
          ["location_id", "in", location_ids],
          ["comment", "!=", false],
          ["starRating", "in", starRatings],
          ["create_date", ">=", `${create_date[0]}`],
          ["create_date", "<", `${create_date[1]}`],
        ];
      } else {
        domain = [
          ["location_id", "in", location_ids],
          ["comment", "!=", false],
          ["starRating", "in", starRatings],
        ];
      }
    } else if (starRatings.length === 0 && create_date.length > 0) {
      domain = [
        ["location_id", "in", location_ids],
        ["comment", "!=", false],
        ["create_date", ">=", `${create_date[0]}`],
        ["create_date", "<", `${create_date[1]}`],
      ];
    } else {
      domain = [
        ["location_id", "in", location_ids],
        ["comment", "!=", false],
      ];
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context, //{"uid":8,"lang":"es_ES"},
        model: "brand_whisper.review",
        domain: domain,
        //[["location_id", "in", location_ids],["comment", "!=", false]],// (For partner)
        // "domain": [["location_id","in",[x,x,x,x]]], (For locations)
        fields: ["comment_eng", "comment", "create_date"], //(Fields you need)
        sort: "",
        limit: 0,
      },
    };

    await this._vm.$http
      .post("/web/dataset/search_read", req_data)
      .then((res) => {
        var commenttabledata_location = res.data.result;
        //console.log.log("commenttabledata_location :::: ", res.data.result);
        commit("commenttabledata_location_success", commenttabledata_location);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async getstarratingpiechartdatabyLocation({ commit }, payload) {
    commit("trustpilot_request");
    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      if (create_date.length > 0) {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
          ["create_date", ">=", `${create_date[0]}`],
          ["create_date", "<", `${create_date[1]}`],
        ];
      } else {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
        ];
      }
    } else if (starRatings.length === 0 && create_date.length > 0) {
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">=", `${create_date[0]}`],
        ["create_date", "<", `${create_date[1]}`],
      ];
    } else {
      domain = [["location_id", "in", location_ids]];
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context, //{"uid":8,"lang":"es_ES"},
          domain: domain,
          //[["location_id","in",location_ids]],//(For partner)
          // "domain": [["location_id","in",[x,x,x,x]]], (For locations)
          fields: ["starRating", "has_comment"],
          groupby: ["starRating", "has_comment"],
          lazy: false,
          orderby: "",
        },
        method: "read_group",
        model: "brand_whisper.review",
        args: [],
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/read_group", req_data)
      .then((res) => {
        var reviewsandcommentdata_location = res.data.result;
        //console.log.log("dashboard starratingpiechartdata_location :::: ", res.data.result);
        commit(
          "starratingpiechartdata_location_success",
          reviewsandcommentdata_location
        );
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async getreviewsandcommentgraphdatabyLocation({ commit }, payload) {
    commit("trustpilot_request");

    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      if (create_date.length > 0) {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
          ["create_date", ">=", `${create_date[0]}`],
          ["create_date", "<", `${create_date[1]}`],
        ];
      } else {
        domain = [
          ["location_id", "in", location_ids],
          ["starRating", "in", starRatings],
        ];
      }
    } else if (starRatings.length === 0 && create_date.length > 0) {
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">=", `${create_date[0]}`],
        ["create_date", "<", `${create_date[1]}`],
      ];
    } else {
      domain = [["location_id", "in", location_ids]];
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context, //{"uid":8,"lang":"es_ES"},
          domain: domain,
          //[["location_id","in",location_ids]],//(For partner)
          // "domain": [["location_id","in",[x,x,x,x]]], (For locations)
          fields: ["starRating", "has_comment"],
          groupby: ["starRating", "has_comment"],
          lazy: false,
          orderby: "",
        },
        method: "read_group",
        model: "brand_whisper.review",
        args: [],
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/read_group", req_data)
      .then((res) => {
        var reviewsandcommentdata_location = res.data.result;
        //console.log.log("dashboard reviewsandcommentdata_location :::: ", res.data.result);
        commit(
          "reviewsandcommentdata_location_success",
          reviewsandcommentdata_location
        );
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async get7daysavgRatingbyLocation({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(7, "d")
      .format("YYYY-MM-DD");

    //console.log.log("payload in get7daysavgRating ", payload);
    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      // if(create_date.length>0){
      //   domain = [["location_id","in",location_ids],["comment","!=",false],["starRating","in",starRatings],["create_date",">=",`${create_date[0]}`],["create_date","<",`${create_date[1]}`] ]
      // }
      // else{
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">", curr_date],
        ["starRating", "in", starRatings],
      ];
      // }
    }
    // else if(starRatings.length === 0 && create_date.length>0){
    //     domain = [["location_id","in",location_ids],["comment","!=",false],["create_date",">=",`${create_date[0]}`],["create_date","<",`${create_date[1]}`]]
    // }
    else {
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">", curr_date],
      ];
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context, //{"uid":8,"lang":"es_ES"},,
          // "domain": [["location_id.partner_id","=",partner_ids],["create_date",">",curr_date]],
          domain: domain,
          // [["location_id","in",location_ids],["create_date",">",curr_date]],
          fields: ["starRating_avg"],
          groupby: ["create_date:day"],
          lazy: false,
          orderby: "",
        },
        method: "read_group",
        model: "brand_whisper.review",
        args: [],
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/read_group", req_data)
      .then((res) => {
        var avg_rating_location = res.data.result;
        //console.log.log("dashboard avg_rating_location :::: ", res.data.result);
        commit("avg_rating_location_success", avg_rating_location);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async get7monthsavgRatingbyLocation({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(7, "months")
      .format("YYYY-MM-DD");

    //console.log.log("payload in get7daysavgRating ", payload);
    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      // if(create_date.length>0){
      //   domain = [["location_id","in",location_ids],["comment","!=",false],["starRating","in",starRatings],["create_date",">=",`${create_date[0]}`],["create_date","<",`${create_date[1]}`] ]
      // }
      // else{
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">", curr_date],
        ["starRating", "in", starRatings],
      ];
      // }
    }
    // else if(starRatings.length === 0 && create_date.length>0){
    //     domain = [["location_id","in",location_ids],["comment","!=",false],["create_date",">=",`${create_date[0]}`],["create_date","<",`${create_date[1]}`]]
    // }
    else {
      domain = [
        ["location_id", "in", location_ids],
        ["create_date", ">", curr_date],
      ];
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context, //{"uid":8,"lang":"es_ES"},
          domain: domain,
          // [["location_id","in",location_ids],["create_date",">",curr_date]], //(When you want partner avg)
          // "domain": [["location_id","in",[x,x,x,x]],[“create_date”,”>”,”YYYY-MM-DD”]], (When you want location avg)
          fields: ["starRating_avg"],
          groupby: ["create_date:month"],
          lazy: false,
          orderby: "",
        },
        method: "read_group",
        model: "brand_whisper.review",
        args: [],
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/read_group", req_data)
      .then((res) => {
        //console.log.log("dashboard month avg_rating :::: ", res.data);
        var avg_rating_location = res.data.result;
        commit("avg_monthrating_location_success", avg_rating_location);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async get7dayscommentsbyLocation({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(365, "d")
      .format("YYYY-MM-DD");

    //console.log.log("payload in get7daysavgRating ", payload);
    var { location_ids, starRatings, create_date } = payload;
    var domain = [];
    if (starRatings !== "" && starRatings.length > 0) {
      // if(create_date.length>0){
      //   domain = [["location_id","in",location_ids],["comment","!=",false],["starRating","in",starRatings],["create_date",">=",`${create_date[0]}`],["create_date","<",`${create_date[1]}`] ]
      // }
      // else{
      domain = [
        ["location_id", "in", location_ids],
        ["comment", "!=", false],
        ["create_date", ">", curr_date],
        ["starRating", "in", starRatings],
      ];
      // }
    }
    // else if(starRatings.length === 0 && create_date.length>0){
    //     domain = [["location_id","in",location_ids],["comment","!=",false],["create_date",">=",`${create_date[0]}`],["create_date","<",`${create_date[1]}`]]
    // }
    // else{
    //   domain = [['location_id','in',location_ids],["comment","!=",false],["create_date",">",curr_date]]
    // }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context, //{"uid":8,"lang":"es_ES"},
          args: domain,
          //[["location_id","in",location_ids],["comment","!=",false],["create_date",">",curr_date]] //(partner count)
          //"args": [["location_id","in",[x,x,x]],[“comment”,”!=”,false],[“create_date”,”>”,”YYYY-MM-DD”]] (location count)
        },
        method: "search_count",
        model: "brand_whisper.review",
        args: [],
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/search_count", req_data)
      .then((res) => {
        //console.log.log("dashboard avg_comments_location :::: ", res.data.result);
        var avg_comment_location = res.data.result;
        commit("avg_comment_location_success", avg_comment_location);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  /*=====Dashboard and TP Overview  APIS =====*/
  async getavgstarratingperday({ commit }, payload) {
    var curr_date = moment()
      .utc()
      .subtract(3, "months")
      .format("YYYY-MM-DD");
    commit("trustpilot_request");
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = []; //[['createTime','>=',curr_date]];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    } else {
      domain.push(["createTime", ">=", curr_date]);
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["starRating_avg", "createTime"], ["createTime:day", "starRating_avg"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var avgstarratingperday = res.data.result;
        //console.log.log("getavgstarratingperday 222:::: ", res.data.result);
        commit("avgstarratingperday_success", avgstarratingperday);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error111", err);
        return err;
      });
  },

  async getavgstarratingpermonth({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(1, "year")
      .format("YYYY-MM-DD");
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = []; //[['createTime','>=',curr_date]];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    } else {
      domain.push(["createTime", ">=", curr_date]);
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["starRating_avg", "createTime"], ["createTime:month"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var avgstarratingpermonth = res.data.result;
        //console.log.log("getavgstarratingpermonth 222:::: ", res.data.result);
        commit("avgstarratingpermonth_success", avgstarratingpermonth);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error111", err);
        return err;
      });
  },

  async getreviewsvscommentovertime({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(1, "year")
      .format("YYYY-MM-DD");

    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = []; //[['createTime','>=',curr_date]];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    } else {
      domain.push(["createTime", ">=", curr_date]);
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["has_comment", "createTime"], ["createTime:month", "has_comment"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var reviewsvscommentovertimedata = res.data.result;
        //console.log.log("reviewsvscommentovertimedata 222:::: ", res.data.result);
        commit("reviewdataovertime_success", reviewsvscommentovertimedata);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error111", err);
        return err;
      });
  },

  async getcommenttabledata({ commit }, payload) {
    commit("trustpilot_request");
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
      offset,
    } = payload;

    var domain = [["comment", "!=", false]];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_read', domain, 
            ["comment_eng", "comment", "createTime"],
            offset,
            80,
            "createTime desc"
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var commenttabledata = res.data.result;
        //console.log.log("commenttabledata commenttabledata :::: ", res.data.result);
        commit("commenttabledata_success", commenttabledata);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async getstarratingpiechartdata({ commit }, payload) {
    commit("trustpilot_request");
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["starRating", "has_comment"], ["starRating", "has_comment"], 0,0,'',false]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var reviewsandcommentdata = res.data.result;
        //console.log.log("dashboard starratingpiechartdata :::: ", res.data.result);
        commit("starratingpiechartdata_success", reviewsandcommentdata);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async getreviewsandcommentgraphdata({ commit }, payload) {
    commit("trustpilot_request");

    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["starRating", "has_comment"], ["starRating", "has_comment"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var reviewsandcommentdata = res.data.result;
        //console.log.log("dashboard reviewsandcommentdata :::: ", res.data.result);
        commit("reviewsandcommentdata_success", reviewsandcommentdata);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async get7daysavgRating({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(7, "d")
      .format("YYYY-MM-DD");

    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [["createTime", ">=", curr_date]];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      // domain.push(["createTime",">=",`${create_date[0]}`])
      // domain.push(["createTime","<=",`${create_date[1]}`])
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }
    // else{
    //   domain = [['location_id.partner_id','=',partner_ids],["create_date",">",curr_date]]
    // }

    //console.log.log("domain in getydaysavgRating", domain);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["starRating_avg"], ["createTime:day"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var avg_rating = res.data.result;
        //console.log.log("dashboard avg_rating :::: ", res.data.result);
        commit("avg_rating_success", avg_rating);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async getPrevWeek7daysavgRating({ commit }, payload) {
    commit("trustpilot_request");
    var last_14_days_date = moment()
      .utc()
      .subtract(14, "d")
      .format("YYYY-MM-DD");
    var last_7_days_date = moment()
      .utc()
      .subtract(7, "d")
      .format("YYYY-MM-DD");

    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [
      ["createTime", ">=", last_14_days_date],
      ["createTime", "<=", last_7_days_date],
    ];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      // domain.push(["createTime",">=",`${create_date[0]}`])
      // domain.push(["createTime","<=",`${create_date[1]}`])
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }
    // else{
    //   domain = [['location_id.partner_id','=',partner_ids],["create_date",">",curr_date]]
    // }

    //console.log.log("domain in getydaysavgRating", domain);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["starRating_avg"], ["createTime:day"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var avg_rating = res.data.result;
        //console.log.log("dashboard avg_rating :::: ", res.data.result);
        commit("avg_rating_prevweek_success", avg_rating);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  async get7monthsavgRating({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(1, "months")
      .format("YYYY-MM-DD");
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [["createTime", ">=", curr_date]];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      // domain.push(["createTime",">=",`${create_date[0]}`])
      // domain.push(["createTime","<=",`${create_date[1]}`])
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["starRating_avg"], ["create_date:month"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("dashboard month avg_rating :::: ", res.data);
        var avg_rating = res.data.result;
        commit("avg_monthrating_success", avg_rating);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },
  async getPrev7monthsavgRating({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(2, "months")
      .format("YYYY-MM-DD");
    var prev_date = moment()
      .utc()
      .subtract(1, "months")
      .format("YYYY-MM-DD");
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [
      ["createTime", ">=", curr_date],
      ["createTime", "<=", prev_date],
    ];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      // domain.push(["createTime",">=",`${create_date[0]}`])
      // domain.push(["createTime","<=",`${create_date[1]}`])
    }
    if (starRatings.length > 0) {
      domain.push(["starRating", "in", starRatings]);
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["starRating_avg"], ["create_date:month"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("dashboard month avg_rating :::: ", res.data);
        var avg_rating = res.data.result;
        commit("avg_prev_monthrating_success", avg_rating);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },
  async get7dayscomments({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(7, "d")
      .format("YYYY-MM-DD");
    // var {
    //   partner_ids,
    //   starRatings,
    //   create_date
    // } = payload;
    // var domain =[];
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [
      ["createTime", ">=", curr_date],
      ["comment", "!=", false],
    ];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      // domain.push(["createTime",">=",`${create_date[0]}`])
      // domain.push(["createTime","<=",`${create_date[1]}`])
    }
    if (starRatings.length > 0) {
      // console.log("starRatings ::: ", starRatings);
      domain.push(["starRating", "in", starRatings]);
    }

    //console.log.log("req payload :: ", payload);
    //console.log.log("domain in 7days comment", domain);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_count', domain ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("dashboard avg_comments :::: ", res.data.result);
        var avg_comment = res.data.result;
        commit("avg_comment_success", avg_comment);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },
  async get7daysPrevWeekcomments({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(14, "d")
      .format("YYYY-MM-DD");
    var curr_last_7_date = moment()
      .utc()
      .subtract(7, "d")
      .format("YYYY-MM-DD");
    // var {
    //   partner_ids,
    //   starRatings,
    //   create_date
    // } = payload;
    // var domain =[];
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [
      ["createTime", ">=", curr_date],
      ["createTime", "<=", curr_last_7_date],
      ["comment", "!=", false],
    ];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      // domain.push(["createTime",">=",`${create_date[0]}`])
      // domain.push(["createTime","<=",`${create_date[1]}`])
    }
    if (starRatings.length > 0) {
      // console.log("starRatings ::: ", starRatings);
      domain.push(["starRating", "in", starRatings]);
    }

    //console.log.log("req payload :: ", payload);
    //console.log.log("domain in 7days comment", domain);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_count', domain
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("dashboard avg_comments :::: ", res.data.result);
        var avg_comment = res.data.result;
        commit("avg_comment_prevweek_success", avg_comment);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },

  //////////======Dashboard and TP Overview  API ends======//////////////
  //////////======Insight Online APIs======//////////////
  async getscoretagcommentCount({ commit }, payload) {
    commit("trustpilot_request");
    // var curr_date = moment().utc().subtract(365,'d').format('YYYY-MM-DD');

    var {
      partner_ids,
      business_unit_ids,
      location_ids,
      starRatings,
      create_date,
      scoreTags,
      topics,
      page_ref,
    } = payload;
    var domain = [
      ["score_tag", "!=", false],
      ["has_comment", "=", true],
    ];
    var rating = [];

    //console.log.log("payload in insight api ", payload);
    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",domain, (business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["starRating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["score_tag", "in", scoreTags]);
    }
    if (topics.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      // domain.push(["Form","in",topic])
    }
    //console.log.log("rating ::: ", payload, rating);
    var grp_by =
      page_ref === "business_unit" ? "business_unit_id" : "location_id";

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["score_tag", "location_city", "description"], [grp_by, "score_tag"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("Insight online scoretag comment count :::: ", res.data.result);
        var scoretagcommentCount_data = res.data.result;
        var scoretagcommentCount = [];
        if (scoretagcommentCount_data.length > 0) {
          scoretagcommentCount = scoretagcommentCount_data;
        }

        commit("scoretagcommentCount_success", scoretagcommentCount);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  async getsentimentanalysisCount({ commit }, payload) {
    commit("trustpilot_request");
    // var curr_date = moment().utc().subtract(365,'d').format('YYYY-MM-DD');

    var {
      partner_ids,
      business_unit_ids,
      location_ids,
      starRatings,
      create_date,
      scoreTags,
      topics,
      page_ref,
    } = payload;
    var domain = [
      ["has_comment", "=", true],
      ["score_tag", "!=", false],
    ];
    var rating = [];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["starRating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["score_tag", "in", scoreTags]);
    }
    if (topics.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      // domain.push(["Form","in",topic])
    }
    // console.log("rating ::: ", payload, rating);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["score_tag"], ["score_tag"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        // console.log("Insight online scoretag comment count :::: ", res.data.result);
        var sentimentanalysisCount_data = res.data.result;
        var sentimentanalysisCount = [];
        if (sentimentanalysisCount_data.length > 0) {
          sentimentanalysisCount = sentimentanalysisCount_data;
        }

        commit("sentimentanalysisCount_success", sentimentanalysisCount);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  async getstarRatingandCommentData({ commit }, payload) {
    commit("trustpilot_request");
    // var curr_date = moment().utc().subtract(365,'d').format('YYYY-MM-DD');

    var {
      partner_ids,
      business_unit_ids,
      location_ids,
      starRatings,
      create_date,
      scoreTags,
      topics,
      page_ref,
      offset,
    } = payload;
    var domain = [
      ["has_comment", "!=", false],
      ["score_tag", "!=", false],
    ];
    var rating = [];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }
    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["starRating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["score_tag", "in", scoreTags]);
    }
    if (topics.length > 0) {
      // rating = ["starRating","in",starRatings]'
      // domain.push(["starRating","in",starRatings])
    }
    // console.log("rating ::: ", payload, rating);
    var fields_value = [];
    if (page_ref === "business_unit") {
      fields_value = [
        "id",
        "business_unit_name",
        "business_unit_id",
        "score_tag",
        "createTime",
        "starRating",
        "comment",
        "comment_eng",
      ];
    }
    if (page_ref === "location") {
      fields_value = [
        "id",
        "location_id",
        "score_tag",
        "createTime",
        "starRating",
        "comment",
        "comment_eng",
      ];
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_read', domain, fields_value,
            offset,
            80,
            "createTime desc"
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        // console.log("Insight online scoretag comment count :::: ", res.data.result);
        var starRatingandCommentData_data = res.data.result;
        var starRatingandCommentData = [];
        if (starRatingandCommentData_data.length > 0) {
          starRatingandCommentData = starRatingandCommentData_data;
        }

        commit("starRatingandCommentData_success", starRatingandCommentData);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  async getscoretagratingovertime({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(1, "year")
      .format("YYYY-MM-DD");

    var {
      partner_ids,
      business_unit_ids,
      location_ids,
      starRatings,
      create_date,
      scoreTags,
      topics,
      page_ref,
    } = payload;
    var domain = []; //[['createTime','>=',curr_date]];

    var rating = [];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["createTime", ">=", `${create_date[0]}`]);
      domain.push(["createTime", "<=", `${create_date[1]}`]);
    } else {
      domain.push(["createTime", ">=", curr_date]);
    }
    if (starRatings.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["starRating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["score_tag", "in", scoreTags]);
    }
    if (topics.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      // domain.push(["Form","in",topic])
    }
    // console.log("rating ::: ", payload, rating);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain
        , ["score_tag", "createTime"], ["score_tag", "createTime:month"], 0,0,"createTime:month",false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("scoretagratingovertime result :::: ", res.data.result);
        var scoretagratingovertime_data = res.data.result;
        var scoretagratingovertime = [];
        if (scoretagratingovertime_data.length > 0) {
          scoretagratingovertime = scoretagratingovertime_data;
        }

        commit("scoretagratingovertime_success", scoretagratingovertime);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  async getcategoryratingovertime({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(1, "year")
      .format("YYYY-MM-DD");

    var {
      partner_ids,
      business_unit_ids,
      location_ids,
      starRatings,
      create_date,
      scoreTags,
      topics,
      page_ref,
    } = payload;
    var domain = []; //[['review_create_time','>=',curr_date]];
    var rating = [];
    //console.log("payload int getcategoryratingovertime::: ", payload);
    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }

    if (create_date.length > 0) {
      domain.push(["review_create_time", ">=", `${create_date[0]}`]);
      domain.push(["review_create_time", "<=", `${create_date[1]}`]);
    } else {
      domain.push(["review_create_time", ">=", curr_date]);
    }
    if (starRatings.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_star_rating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_score_tag", "in", scoreTags]);
    }
    if (topics.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      // domain.push(["Form","in",topic])
    }
    // console.log("rating ::: ", payload, rating);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.topic', 'read_group', domain
        , [
            "review_create_time",
            "category_id",
            "review_star_rating_avg",
          ], ["category_id", "review_create_time:month"], 0, 0, '', false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("categoryratingovertime result :::: ", res.data.result);
        var categoryratingovertime_data = res.data.result;
        var categoryratingovertime = [];
        if (categoryratingovertime_data.length > 0) {
          categoryratingovertime = categoryratingovertime_data;
        }

        commit("categoryratingovertime_success", categoryratingovertime);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  async gettopicstarratingCount({ commit }, payload) {
    commit("trustpilot_request");
    // var curr_date = moment().utc().subtract(365,'d').format('YYYY-MM-DD');

    var {
      partner_ids,
      business_unit_ids,
      location_ids,
      starRatings,
      create_date,
      scoreTags,
      topics,
      page_ref,
    } = payload;
    var domain = [["category_id", "!=", false]];
    var rating = [];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_create_time", ">=", `${create_date[0]}`]);
      domain.push(["review_create_time", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      domain.push(["review_star_rating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_score_tag", "in", scoreTags]);
    }
    if (topics.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["Form", "in", topic]);
    }
    // console.log("rating ::: ", payload, rating);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.topic', 'read_group', domain
        , ["category_id"], ["category_id"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("categoryratingovertime result :::: ", res.data.result);
        var topicstarratingCount_data = res.data.result;
        var topicstarratingCount = [];
        if (topicstarratingCount_data.length > 0) {
          topicstarratingCount = topicstarratingCount_data;
        }

        commit("topicstarratingCount_success", topicstarratingCount);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  async gettopicavgstarratingCount({ commit }, payload) {
    commit("trustpilot_request");
    // var curr_date = moment().utc().subtract(365,'d').format('YYYY-MM-DD');

    var {
      partner_ids,
      business_unit_ids,
      location_ids,
      starRatings,
      create_date,
      scoreTags,
      topics,
      page_ref,
    } = payload;
    var domain = [["category_id", "!=", false]];
    var rating = [];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_create_time", ">=", `${create_date[0]}`]);
      domain.push(["review_create_time", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      domain.push(["review_star_rating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_score_tag", "in", scoreTags]);
    }
    if (topics.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      // domain.push(["Form","in",topic])
    }
    // console.log("rating ::: ", payload, rating);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.topic', 'read_group', domain
        , ["category_id", "review_star_rating_avg"], ["category_id"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("categoryratingovertime result :::: ", res.data.result);
        var topicavgstarrating_data = res.data.result;
        var topicavgstarrating = [];
        if (topicavgstarrating_data.length > 0) {
          topicavgstarrating = topicavgstarrating_data;
        }

        commit("topicavgstarrating_success", topicavgstarrating);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  async getformdataCount({ commit }, payload) {
    commit("trustpilot_request");
    // var curr_date = moment().utc().subtract(365,'d').format('YYYY-MM-DD');

    var {
      partner_ids,
      business_unit_ids,
      location_ids,
      starRatings,
      create_date,
      scoreTags,
      topics,
      page_ref,
    } = payload;
    var domain = [];
    var rating = [];

    if (business_unit_ids.length > 0) {
      if (business_unit_ids[0] === partner_ids[0]) {
        domain.push(["business_unit_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["business_unit_id", "in", business_unit_ids]);
      }
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["location_id.partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    }
    //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    if (business_unit_ids.length === 0 && location_ids.length === 0) {
      //console.log.log( "No location selected", page_ref);
      if (page_ref === "location")
        domain.push(["location_id.partner_id", "in", partner_ids]);
      if (page_ref === "business_unit") {
        domain.push(["business_unit_id.partner_id", "in", partner_ids]);
      }
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_create_time", ">=", `${create_date[0]}`]);
      domain.push(["review_create_time", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_star_rating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["review_star_rating","in",starRatings]'
      domain.push(["review_score_tag", "in", scoreTags]);
    }
    if (topics.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["Form", "in", topic]);
    }
    //console.log.log("rating ::: in form", payload);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.topic', 'read_group', domain
        , ["Form"], ["Form"], 0,0,'',false]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("formdataCount result :::: ", res.data.result);
        var formdataCount_data = res.data.result;
        var formdataCount = [];
        // console.log(formdataCount_data, "   $$$$formdataCount_data");
        if (formdataCount_data.length > 0) {
          var sorted_data = _.sortBy(formdataCount_data, "__count").reverse();
          formdataCount = sorted_data.slice(0, 500);
          // formdataCount = sorted_data;
        }

        commit("formdataCount_success", formdataCount);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  //////////======Insight Online APIs End======//////////////
  async getBusinessUnits({ commit }, partner_ids) {
    commit("trustpilot_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.business_unit', 'search_read', [["partner_id", "=", partner_ids]], ["id", "name", "description", "city", "address", "partner_id"],
            0,
            0,
            ""
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var trustpilot_data = res.data.result;
        var trustpilot = [];
        //console.log.log("trustpilot business Unit :::: ", res.data.result);
        if (trustpilot_data.length > 0) {
          trustpilot = trustpilot_data;
        }
        commit("trustpilot_success", trustpilot);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },

  async getdatastudioSentimentTP({ commit }, partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiosentiment", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'business_unit_name',('business_unit_id',['id', 'name', 'city', 'description', ('partner_id',['id','name'])]),'score_tag', 'create_time', 'star_rating','comment', 'comment_eng']",
        },
        params: {
          limit: 0,
          args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],["business_unit_id.partner_id.id", "in", [${partner_ids}]]]`,
          // args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],["location_id.partner_id.name", "=", "Apache",],]`
        },
      })
      .then((res) => {
        var insight_tp = res.data;
        commit("trustpilot_insight_success", insight_tp);
        return res;
      })
      .catch((err) => {
        commit("insight_error");
        return err;
      });
  },
  async getdatastudioSentimentStarRatingTP({ commit }, partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiosentiment", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['star_rating','score_tag', ('business_unit_id',['id','name',('partner_id',['id','name']), 'city','description'])]",
        },
        params: {
          limit: 0,
          args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],["business_unit_id.partner_id.id", "in", [${partner_ids}]]]`,
          // args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],["location_id.partner_id.name", "=", "Apache",],]`
        },
      })
      .then((res) => {
        var starRating = res.data;
        //console.log.log("starRating", res.data);
        commit("trustpilot_starrating_success", starRating);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },

  async getdatastudioTopicsTP({ commit }, partner_ids) {
    commit("trustpilot_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiotopics", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'topic_form','category_name',('category_id',['id','name']), ('business_unit_id',['id','name',('partner_id',['id','name']), 'city','description']), 'score_tag', 'create_time', 'star_rating']",
        },
        params: {
          limit: 0,
          args: `[["category_name", "!=", "false",],["business_unit_id.partner_id.id", "in", [${partner_ids}]]]`,
          // args: `[["category_name", "!=", "false",],["location_id.partner_id.name", "=", "Apache",],]`
        },
      })
      .then((res) => {
        var topic = res.data;
        commit("topic_success", topic);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },
  async getCategoryNameTopicsTP({ commit }, partner_ids) {
    commit("trustpilot_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiotopics", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['topic_form','category_name', ('business_unit_id',['id','name',('partner_id',['id','name']), 'city','description'])]",
        },
        params: {
          limit: 0,
          args: `[["category_name", "!=", "false",], ["business_unit_id.partner_id.id", "in", [${partner_ids}]]]`,
          // args: `[["category_name", "!=", "false",],["location_id.partner_id.name", "=", "Apache",],]`
        },
      })
      .then((res) => {
        var category_name = res.data;
        commit("category_name_success", category_name);
        return res;
      })
      .catch((err) => {
        commit("trustpilot_error");
        return err;
      });
  },

  // New Two Api of Frescura
  async getfrescuraReviews({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(7, "d")
      .format("YYYY-MM-DD");
    // var {
    //   partner_ids,
    //   starRatings,
    //   create_date
    // } = payload;
    // var domain =[];
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [
      // ["createTime", ">=", curr_date]
    ];
    if (partner_ids.length) {
      domain.push(["partner_id", "in", partner_ids]);
    }

    // if (business_unit_ids.length > 0) {
    //   if (business_unit_ids[0] === partner_ids[0]) {
    //     domain.push(["business_unit_id.partner_id", "in", partner_ids]);
    //   } else {
    //     domain.push(["business_unit_id", "in", business_unit_ids]);
    //   }
    // }
    // if (location_ids.length > 0) {
    //   if (location_ids[0] === partner_ids[0]) {
    //     domain.push(["location_id.partner_id", "=", partner_ids]);
    //   } else {
    //     domain.push(["location_id", "in", location_ids]);
    //   }
    // }
    // //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    // if (business_unit_ids.length === 0 && location_ids.length === 0) {
    //   //console.log.log( "No location selected", page_ref);
    //   if (page_ref === "location")
    //     domain.push(["location_id.partner_id", "in", partner_ids]);
    //   if (page_ref === "business_unit") {
    //     domain.push(["business_unit_id.partner_id", "in", partner_ids]);
    //   }
    // }
    // if (create_date.length > 0) {
    //   // domain.push(["createTime",">=",`${create_date[0]}`])
    //   // domain.push(["createTime","<=",`${create_date[1]}`])
    // }
    // if (starRatings.length > 0) {
    //   // console.log("starRatings ::: ", starRatings);
    //   domain.push(["starRating", "in", starRatings]);
    // }

    //console.log.log("req payload :: ", payload);
    //console.log.log("domain in 7days comment", domain);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_count', domain ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("dashboard avg_comments :::: ", res.data.result);
        var result = res.data.result;
        commit("frescura_reviews_success", result);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },
  async getfrescuraComments({ commit }, payload) {
    commit("trustpilot_request");
    var curr_date = moment()
      .utc()
      .subtract(7, "d")
      .format("YYYY-MM-DD");
    // var {
    //   partner_ids,
    //   starRatings,
    //   create_date
    // } = payload;
    // var domain =[];
    var {
      partner_ids,
      location_ids,
      business_unit_ids,
      starRatings,
      create_date,
      page_ref,
    } = payload;

    var domain = [
      // ["createTime", ">=", curr_date]
      ["has_comment", ">=", true],
    ];
    if (partner_ids.length) {
      domain.push(["partner_id", "in", partner_ids]);
    }

    // if (business_unit_ids.length > 0) {
    //   if (business_unit_ids[0] === partner_ids[0]) {
    //     domain.push(["business_unit_id.partner_id", "in", partner_ids]);
    //   } else {
    //     domain.push(["business_unit_id", "in", business_unit_ids]);
    //   }
    // }
    // if (location_ids.length > 0) {
    //   if (location_ids[0] === partner_ids[0]) {
    //     domain.push(["location_id.partner_id", "=", partner_ids]);
    //   } else {
    //     domain.push(["location_id", "in", location_ids]);
    //   }
    // }
    // //console.log.log("=========>",(business_unit_ids.length === 0) && (location_ids.length === 0));
    // if (business_unit_ids.length === 0 && location_ids.length === 0) {
    //   //console.log.log( "No location selected", page_ref);
    //   if (page_ref === "location")
    //     domain.push(["location_id.partner_id", "in", partner_ids]);
    //   if (page_ref === "business_unit") {
    //     domain.push(["business_unit_id.partner_id", "in", partner_ids]);
    //   }
    // }
    // if (create_date.length > 0) {
    //   // domain.push(["createTime",">=",`${create_date[0]}`])
    //   // domain.push(["createTime","<=",`${create_date[1]}`])
    // }
    // if (starRatings.length > 0) {
    //   // console.log("starRatings ::: ", starRatings);
    //   domain.push(["starRating", "in", starRatings]);
    // }

    //console.log.log("req payload :: ", payload);
    //console.log.log("domain in 7days comment", domain);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_count', domain]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log.log("dashboard avg_comments :::: ", res.data.result);
        var result = res.data.result;
        commit("frescura_comments_success", result);
        return res;
      })
      .catch((err) => {
        commit("dashboard_error");
        return err;
      });
  },
};
//mutations

export var trustpilotMutations = {
  trustpilot_request(state) {
    state.status_trustpilot = "loading";
  },
  trustpilot_success(state, payload) {
    state.status_trustpilot = "success";
    state.business_units = payload;
  },
  trustpilot_insight_success(state, payload) {
    state.status_trustpilot = "success";
    state.insights_tp = payload;
  },
  trustpilot_starrating_success(state, payload) {
    state.status_trustpilot = "success";
    state.starRating_tp = payload;
  },
  topic_success(state, payload) {
    state.status_trustpilot = "success";
    state.topics_tp = payload;
  },
  category_name_success(state, payload) {
    state.status_trustpilot = "success";
    state.category_topic_tp = payload;
  },
  comment_success(state, payload) {
    state.status_trustpilot = "success";
    state.commentcount_tp = payload;
  },
  analyzeinsightfirsttp_success(state, payload) {
    state.status_trustpilot = "success";
    state.analyzeinsightfirst_tp = payload;
  },
  analyzeinsightthirdtp_success(state, payload) {
    state.status_trustpilot = "success";
    state.analyzeinsightthird_tp = payload;
  },
  analyzeinsightfourthtp_success(state, payload) {
    state.status_trustpilot = "success";
    state.analyzeinsightfourth_tp = payload;
  },
  analyzeinsightfifthtp_success(state, payload) {
    state.status_trustpilot = "success";
    state.analyzeinsightfifth_tp = payload;
  },
  trustpilot_gbareviews_success(state, payload) {
    state.status_trustpilot = "success";
    state.reviews_tp = payload;
  },
  trustpilot_error(state) {
    state.status_trustpilot = "error";
  },
  avg_rating_success(state, payload) {
    state.status_dashboard = "success";
    state.avg_rating = payload;
  },
  avg_rating_prevweek_success(state, payload) {
    state.status_dashboard = "success";
    state.avg_rating_prevweek = payload;
  },
  avg_monthrating_success(state, payload) {
    state.status_dashboard = "success";
    state.month_avg_rating = payload;
  },
  avg_prev_monthrating_success(state, payload) {
    state.status_dashboard = "success";
    state.month_avg_rating_prev = payload;
  },
  avg_comment_success(state, payload) {
    state.status_dashboard = "success";
    //console.log.log("payload in comment", payload);
    state.avg_comment = payload;
  },
  avg_comment_prevweek_success(state, payload) {
    state.status_dashboard = "success";
    //console.log.log("payload in comment", payload);
    state.avg_comment_prevweek = payload;
  },
  reviewsandcommentdata_success(state, payload) {
    state.status_dashboard = "success";
    state.reviewsandcommentdata = payload;
  },

  starratingpiechartdata_success(state, payload) {
    state.status_dashboard = "success";
    state.starratingpiechartdata = payload;
  },
  commenttabledata_success(state, payload) {
    state.status_dashboard = "success";
    state.commenttabledata = payload;
  },
  reviewdataovertime_success(state, payload) {
    state.status_dashboard = "success";
    state.reviewsvscommentovertimedata = payload;
  },
  avgstarratingperday_success(state, payload) {
    state.status_dashboard = "success";
    state.avgstarratingperday = payload;
  },
  avgstarratingpermonth_success(state, payload) {
    state.status_dashboard = "success";
    state.avgstarratingpermonth = payload;
  },
  avgstarratingperday_location_success(state, payload) {
    state.status_dashboard = "success";
    state.avgstarratingperday_location = payload;
  },
  avg_comment_location_success(state, payload) {
    state.status_dashboard = "success";
    //console.log.log("payload in comment", payload);
    state.avg_comment_location = payload;
  },
  avg_monthrating_location_success(state, payload) {
    state.status_dashboard = "success";
    state.month_avg_rating_location = payload;
  },
  avg_rating_location_success(state, payload) {
    state.status_dashboard = "success";
    state.avg_rating_location = payload;
  },
  reviewsandcommentdata_location_success(state, payload) {
    state.status_dashboard = "success";
    state.reviewsandcommentdata_location = payload;
  },
  starratingpiechartdata_location_success(state, payload) {
    state.status_dashboard = "success";
    state.starratingpiechartdata_location = payload;
  },
  commenttabledata_location_success(state, payload) {
    state.status_dashboard = "success";
    state.commenttabledata_location = payload;
  },
  reviewdataovertime_location_success(state, payload) {
    state.status_dashboard = "success";
    state.reviewsvscommentovertimedata_location = payload;
  },
  avgstarratingpermonth_location_success(state, payload) {
    state.status_dashboard = "success";
    state.avgstarratingpermonth_location = payload;
  },
  scoretagcommentCount_success(state, payload) {
    state.status_dashboard = "success";
    //console.log.log("payload :::: ", payload);
    state.scoretagcommentCount = payload;
  },
  sentimentanalysisCount_success(state, payload) {
    state.status_dashboard = "success";
    // console.log("payload :::: ", payload);
    state.sentimentanalysisCount = payload;
  },
  starRatingandCommentData_success(state, payload) {
    state.status_dashboard = "success";
    // console.log("payload :::: ", payload);
    state.starRatingandCommentData = payload;
  },
  scoretagratingovertime_success(state, payload) {
    state.status_dashboard = "success";
    //console.log.log("payload scoretagratingovertime:::: ", payload);
    state.scoretagratingovertime = payload;
  },
  categoryratingovertime_success(state, payload) {
    state.status_dashboard = "success";
    // console.log("payload categoryratingovertime_success:::: ", payload);
    state.categoryratingovertime = payload;
  },
  topicstarratingCount_success(state, payload) {
    state.status_dashboard = "success";
    // console.log("payload categoryratingovertime_success:::: ", payload);
    state.topicstarratingCount = payload;
  },
  topicavgstarrating_success(state, payload) {
    state.status_dashboard = "success";
    // console.log("payload categoryratingovertime_success:::: ", payload);
    state.topicavgstarrating = payload;
  },
  formdataCount_success(state, payload) {
    state.status_dashboard = "success";
    state.formdataCount = payload;
  },
  frescura_reviews_success(state, payload) {
    state.status_dashboard = "success";
    state.frescura_reviews = payload;
  },
  frescura_comments_success(state, payload) {
    state.status_dashboard = "success";
    state.frescura_comments = payload;
  },
};
